<template>
  <div>
    <h1>RAFAEL MORAIS DE ASSIS</h1>
    <p>
    Olá. Sou desenvolvedor Full-Stack e um entusiasta de Machine Learning. Natural de Eunápolis/BA e cursando Ciência da Computação em Uberlândia/MG.
    </p>
    <div class="is-flex-direction-row" style="justify-content: center !important">
      <a href="https://github.com/rafanthx13">
        <b-icon class="mx-2" pack="mdi" icon="github" size="is-medium" />
      </a>
      <a href="https://www.linkedin.com/in/rafael-m-de-assis/">
        <b-icon class="mx-2" pack="mdi" icon="linkedin" size="is-medium" />
      </a>
      <a href="rafaassis15@gmail.com">
        <b-icon class="mx-2" pack="mdi" icon="email" size="is-medium" />
      </a>
      <a href="https://rafanthx13.github.io/">
         <b-icon class="mx-2" pack="mdi" icon="card-account-details-outline" size="is-medium" />
      </a>
    </div>

  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>

</style>
